<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :label="label"
    :loading="loading"
    :search-input.sync="search"
    multiple
    chips
    clearable
    item-value="id"
    item-text="text"
    outlined
    dense
    prepend-icon="person_outline"
    placeholder="Search passengers..."
    cache-items
  >
    <template slot="selection" slot-scope="data">
      <v-chip
        :selected="data.selected"
        close
        @input="remove(data.item.id)"
        small
      >
        {{ data.item.text }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "RidesPassengerFilter",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Passengers",
    },
  },
  data() {
    return {
      model: this.value || [],
      search: null,
      loading: false,
      items: [],
    };
  },
  watch: {
    value(newVal) {
      this.model = newVal || [];
    },
    model(newVal) {
      this.$emit("input", newVal);
    },
    search(val) {
      if (val === null) return;
      this.loadData(val);
    },
  },
  mounted() {
    // Load initial data
    this.loadData("");
  },
  methods: {
    loadData(searchVal) {
      this.loading = true;
      const params = new URLSearchParams();
      if (searchVal) {
        params.append("search", searchVal);
      }
      this.axios
        .get(this.api.ACTIONS.PASSENGERS, { params })
        .then((res) => {
          const { data } = res.data.data;
          this.items = data.map((item) => ({
            id: item.id,
            text: `${item.full_name} (${item.username})`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    remove(id) {
      this.model = this.model.filter((item) => item !== id);
    },
  },
};
</script>

<style scoped>
</style>

